import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserDashboard from '../pages/UserDashboard';
import SendSMS from '../pages/SendSMS';
import Templates from '../pages/user/dlt/Templates';
import UserTemplateAnalytics from '../pages/user/TemplateAnalytics';
import Headers from '../pages/super/dlt/Headers';
import Reports from '../pages/user/Reports';
import ReportsDetailed from '../pages/user/ReportsDetailed';
import ReportsSummary from '../pages/user/ReportsSummary';
import Settings from '../pages/user/Settings';
import ApiManagement from '../pages/user/ApiManagement';
import ModernSidebarV2 from '../components/layout/ModernSidebarV2';
import ModernHeaderV2 from '../components/layout/ModernHeaderV2';

const UserLayoutModern = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigation = [
    { name: 'Dashboard', href: '/', icon: 'LayoutDashboard' },
    { name: 'Send SMS', href: '/send-sms', icon: 'Send' },
    { 
      name: 'DLT', 
      icon: 'FileCheck',
      menuKey: 'dlt',
      children: [
        { name: 'Headers', href: '/dlt/headers', icon: 'Heading' },
        { name: 'Templates', href: '/dlt/templates', icon: 'FileText' },
        { name: 'Template Analytics', href: '/dlt/template-analytics', icon: 'BarChart3' },
      ]
    },
    { 
      name: 'Reports', 
      icon: 'BarChart3',
      menuKey: 'reports',
      children: [
        { name: 'Detailed SMS', href: '/reports/detailed', icon: 'FileText' },
        { name: 'SMS Summary', href: '/reports/summary', icon: 'BarChart3' },
      ]
    },
    { name: 'API Management', href: '/api-management', icon: 'Code2' },
    { name: 'Settings', href: '/settings', icon: 'Settings' },
  ];

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-50">
      <ModernHeaderV2
        setSidebarOpen={setSidebarOpen}
        user={user}
      />

      <div className="flex flex-1 overflow-hidden" style={{ paddingTop: '60px' }}>
        <ModernSidebarV2
          navigation={navigation}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          user={user}
          logout={logout}
        />

        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="lg:ml-[240px] p-4 sm:p-6 max-w-[1600px] mx-auto">
            <Routes>
              <Route path="/" element={<UserDashboard />} />
              <Route path="/send-sms" element={<SendSMS />} />
              <Route path="/dlt/headers" element={<Headers />} />
              <Route path="/dlt/templates" element={<Templates />} />
              <Route path="/dlt/template-analytics" element={<UserTemplateAnalytics />} />
              <Route path="/reports/detailed" element={<ReportsDetailed />} />
              <Route path="/reports/summary" element={<ReportsSummary />} />
              <Route path="/api-management" element={<ApiManagement />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UserLayoutModern;
